import { defineStore } from 'pinia';
import type { MenuItem } from './types/menuItem';
import { nestItems } from './utils/nestItems';

interface State {
  debug: boolean;
  items: any[];
}

export const useMenuStore = defineStore('menu', {
  state: (): State => ({
    debug: false,
    items: [],
  }),

  getters: {
    nestedItems(): MenuItem[] {
      return nestItems(this.items);
    },
  },
});
